import {
  SortDirection,
  StatisticEventDTO,
} from 'src/app/base/models/models.swagger.generated';
import { defineDynamicEntityDefinition, textColumn } from 'src/app/base/shared/dynamic/dynamic-entity-definition';

export const statisticEventsDynamicDefinition = defineDynamicEntityDefinition<StatisticEventDTO, StatisticEventDTO, StatisticEventDTO>({
  entityName: 'statistic-event',
  primaryKey: 'id',
  defaultSort: {
    field: 'OccurredUtc',
    direction: SortDirection.Descending,
  },
  grid: {
    searchFields: [],
    columns: [
      { field: 'id', headerKey: 'i18n.shared.fields.id', type: 'number', visible: false, sortable: false, allowFiltering: false },
      { field: 'vehicleId', headerKey: 'i18n.domain.analytics.statistic-events.columns.vehicle-id', type: 'number', visible: false },
      {
        field: 'tripId',
        headerKey: 'i18n.domain.analytics.statistic-events.columns.trip-id',
        type: 'number',
        filter: { kind: 'number' },
      },
      textColumn<StatisticEventDTO>('eventType', 'i18n.domain.analytics.statistic-events.columns.event-type'),
      textColumn<StatisticEventDTO>('moduleName', 'i18n.domain.analytics.statistic-events.columns.module-name'),
      {
        field: 'occurredUtc',
        headerKey: 'i18n.domain.analytics.statistic-events.columns.occurred',
        type: 'date',
        clipMode: 'EllipsisWithTooltip',
        filter: { kind: 'date' },
        formatValue: (row: StatisticEventDTO) => row.occurredUtc ? row.occurredUtc.toFormat('dd.MM.yyyy HH:mm') : '',
      },
      {
        field: 'severity',
        headerKey: 'i18n.domain.analytics.statistic-events.columns.severity',
        type: 'number',
        filter: { kind: 'number' },
      },
    ],
  },
  form: {
    fields: [],
    layout: [],
  },
  // Event data is read-only (StatisticsController only exposes SearchEvents) — add/edit are never triggered
  // since the grid disables allowAdding/allowEditing/allowDeleting, so these are unused identity pass-throughs.
  mapToCreate: (formValue: StatisticEventDTO): StatisticEventDTO => formValue,
  mapToUpdate: (formValue: StatisticEventDTO): StatisticEventDTO => formValue,
});
